"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useBannerProductListingContext = exports.defaultBannerProductListingContextValues = exports.BannerproductListingContext = exports.BannerProductListingProvider = void 0;
var _react = require("react");
var _constants = require("../components/BannerProductListing/constants");
var _useFilterValue = require("../components/BannerProductListing/utils/useFilterValue");
var _useGetPaginatedData = require("../components/BannerProductListing/utils/useGetPaginatedData");
var _useSortValue = require("../components/BannerProductListing/utils/useSortValue");
var _utils = require("../utils");
var _mapFacetQueryToFilterValues = require("../utils/mapFacetQueryToFilterValues");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore next @preserve -- No need to test default values.
const defaultBannerProductListingContextValues = exports.defaultBannerProductListingContextValues = {
    data: null,
    pageId: '',
    content: null,
    isFocusPage: false,
    appliedFacets: [],
    setAppliedFacets: async ()=>{},
    orderBy: _constants.DEFAULT_ORDER_BY,
    setOrderBy: async ()=>new URLSearchParams(),
    getFacets: async ()=>[],
    getData: async ()=>undefined,
    loadMoreItems: async ()=>{},
    isLoadingMore: false,
    isRefreshing: false,
    enableFetch: ()=>{}
};
const BannerproductListingContext = exports.BannerproductListingContext = /*#__PURE__*/ (0, _react.createContext)(defaultBannerProductListingContextValues);
const { Provider } = BannerproductListingContext;
const BannerProductListingProvider = (param)=>{
    let { children, isFocusPage, isPLP, pageId, data, getFacets, getData, query, hasFilters } = param;
    const [skip, setSkip] = (0, _react.useState)(_constants.SERVER_PAGINATION_LIMIT_ROWS);
    const [paginationLoading, setPaginationLoading] = (0, _react.useState)(false);
    const [sortLoading, setSortLoading] = (0, _react.useState)(false);
    const { orderBy, setOrderBy } = (0, _useSortValue.useSortValue)();
    const { facetsQuery, setFacetsQuery } = (0, _useFilterValue.useFilterValue)((0, _utils.mapFacetFilterValuesToFacetQuery)((0, _utils.mapFacetFilterFromApi)(data === null || data === void 0 ? void 0 : data.facets), false));
    const { content, loadMoreItems, isRefreshing, isLoadingMore, enableFetch } = (0, _useGetPaginatedData.useGetPaginatedData)({
        getData,
        data,
        appliedFacets: facetsQuery,
        orderBy,
        pageId: pageId !== null && pageId !== void 0 ? pageId : '',
        hasFilters
    });
    const setAppliedFacetAndQuery = (0, _react.useCallback)(async (values)=>{
        await setFacetsQuery((0, _utils.mapFacetFilterValuesToFacetQuery)(values));
    }, [
        setFacetsQuery
    ]);
    const value = (0, _react.useMemo)(()=>({
            query,
            data,
            pageId: pageId !== null && pageId !== void 0 ? pageId : '',
            content,
            skip,
            setSkip,
            paginationLoading,
            setPaginationLoading,
            isFocusPage,
            isPLP,
            sortLoading,
            setSortLoading,
            appliedFacets: (0, _mapFacetQueryToFilterValues.mapFacetQueryToFilterValues)(facetsQuery, (0, _utils.mapFacetFilterFromApi)(data === null || data === void 0 ? void 0 : data.facets)),
            setAppliedFacets: setAppliedFacetAndQuery,
            orderBy,
            setOrderBy,
            getFacets,
            getData,
            loadMoreItems,
            isLoadingMore,
            isRefreshing,
            enableFetch
        }), [
        query,
        data,
        pageId,
        content,
        skip,
        paginationLoading,
        isFocusPage,
        isPLP,
        sortLoading,
        facetsQuery,
        setAppliedFacetAndQuery,
        orderBy,
        setOrderBy,
        getFacets,
        getData,
        loadMoreItems,
        isLoadingMore,
        isRefreshing,
        enableFetch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.BannerProductListingProvider = BannerProductListingProvider;
const useBannerProductListingContext = ()=>(0, _react.useContext)(BannerproductListingContext);
exports.useBannerProductListingContext = useBannerProductListingContext;
